/** @prettier */

import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import en from '../../intl/translations/en';
import { clickedSubscribeCTA } from '../../actions/segmentEvents';
import config from '../../config';

const CamHeaderCTA = ({ href, segmentProperties }) => {
  const dispatch = useDispatch();
  const onClickPaywall = () => dispatch(clickedSubscribeCTA(segmentProperties));

  return (
    <div className="sl-cam-header-cta">
      <span className="sl-cam-header-cta__text">{en.premiumCTA.CamHeaderCTA.text}</span>
      <a href={href} className="sl-cam-header-cta__link" onClick={onClickPaywall}>
        {en.premiumCTA.CamHeaderCTA.linkText}
      </a>
    </div>
  );
};

CamHeaderCTA.defaultProps = {
  href: config.funnelUrl,
  segmentProperties: {},
};

CamHeaderCTA.propTypes = {
  href: PropTypes.string,
  segmentProperties: PropTypes.shape({}),
};

export default CamHeaderCTA;
